var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5933 2.41614C20.4794 1.99354 20.2568 1.60815 19.9477 1.29831C19.6386 0.988473 19.2537 0.765003 18.8313 0.650142C17.2653 0.220142 11.0003 0.213142 11.0003 0.213142C11.0003 0.213142 4.73633 0.206142 3.16933 0.617142C2.74725 0.737289 2.36315 0.963919 2.0539 1.27528C1.74464 1.58663 1.52062 1.97226 1.40333 2.39514C0.99033 3.96114 0.98633 7.20914 0.98633 7.20914C0.98633 7.20914 0.98233 10.4731 1.39233 12.0231C1.62233 12.8801 2.29733 13.5571 3.15533 13.7881C4.73733 14.2181 10.9853 14.2251 10.9853 14.2251C10.9853 14.2251 17.2503 14.2321 18.8163 13.8221C19.2388 13.7075 19.6241 13.4845 19.934 13.1753C20.2439 12.8661 20.4677 12.4814 20.5833 12.0591C20.9973 10.4941 21.0003 7.24714 21.0003 7.24714C21.0003 7.24714 21.0203 3.98214 20.5933 2.41614ZM8.99633 10.2181L9.00133 4.21814L14.2083 7.22314L8.99633 10.2181Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.5bdb3b0076507257bf92d6dc762086df.svg";
export { ForwardRef as ReactComponent };